<template>
    <div class="container order-logistics-container" v-cloak>
        <div class="header f-s-b">
            <div class="right-box f-s-b">
                <i class="iconfont iconjiantouarrow487 icon-image" v-touch:tap="back"></i>
                <van-image
                    class="header-image"
                    :src="getImage"
                />
                <span class="text" v-if="statusObj.isSuccess">已完成</span>
                <span class="text" v-else-if="statusObj.isDeliver">派件中</span>
                <span class="text" v-else>运输中</span>
            </div>
            <!-- <i class="iconhebei icongengduo" v-touch:tap.prevent="onChangehow"></i> -->
        </div>

        <div class="map-box drawing-map-box">
            <div class="" id="container"></div>
            <div class="" id="panel"></div>
        </div>

        <div class="logistics-name-box f-s-b">
            <van-image
                class="logistics-image"
                :src="getImage"
            />
            <div class="info-box">
                <div class="logistics-name" style="margin:0;">{{detail.ORDER_GOODS_DETAILS[0].PRODUCT_NAME}}</div>
            </div>
        </div>

        <div class="logistics-name-box f-s-b product-box">
            <van-image
                class="logistics-image"
                :src="defaultImage[0]"
            />
            <div class="info-box">
                <div class="logistics-name">{{expressName(option.disName || option.com) || '暂无快递公司名称'}}</div>
                <div class="logistics-number">
                    <span>快递单号: &nbsp; {{option.nu}}</span>
                </div>
            </div>
        </div>

        <ul class="render-logistics-info-box">
            <li class="item-box f-s-b" >
                <div class="date-box">
                </div>
                <div class="icon-box f-c">
                    <span class="receiving-icon f-c" :class="statusObj.isSuccess ? 'icon-quanquan-active':''">收</span>
                </div>
                <div class="info-box">
                    【收货地址】{{detail.distribution.detailAddress}}
                </div>
            </li>
            <li class="item-box f-s-b" v-for="(item, index) in option.data" :key="index">
                <div class="date-box">
                    <div class="date">
                        {{logisticsDate(item.ftime)}}
                    </div>
                    <div class="time">
                        {{logisticsDate(item.ftime, false)}}
                    </div>
                </div>
                <div class="icon-box f-c" v-if="statusObj.isTransport && index === 0">
                    <span class="iconhebei iconkuaidi icon-quanquan icon-quanquan-active"></span>
                </div>
                <div class="icon-box f-c" v-else-if="statusObj.isSuccess && index === 0">
                    <span class="iconhebei iconwancheng icon-success"></span>
                </div>
                <div class="icon-box f-c" v-else>
                    <span class="iconhebei iconkuaidi icon-quanquan" v-if="index === (option.data.length - 1)"></span>
                    <span class="quan-box" v-else></span>
                </div>
                <div class="info-box">
                    {{item.context}}
                </div>
            </li>
        </ul>

        <div class="logistics-info-box" hidden>
            <van-steps 
                class="info-box"
                direction="vertical" 
                :active="0"
            >
                <van-step
                    v-for="(item, index) in option.data" :key="index"
                    >
                    <h3>{{item.context}}</h3>
                    <p>{{item.ftime}}</p>
                </van-step>
            </van-steps>
        </div>


        <van-popup
            class="popup-box"
            v-model="show"
            round
            position="top"
            :style="{ height: '30%' }"
        >
            <ul class="popup-render-box">

            </ul>
        </van-popup>

    </div>
</template>

<script>
    import { 
        Step,
        Steps,
        Popup,
    } from 'vant';
    import http from "@js/http-hbt.js";
    import {
        expressInfoUrl,
        getOrderDetail,
    } from "@js/shoppingUrl.js";
    export default {
        data() {
            return {
                option:{
                    data: [],
                },
                detail: {
                    ORDER_GOODS_DETAILS: [{
                        COVER_URL: ''
                    }],
                    distribution: {
                        detailAddress: ''
                    }
                },
                defaultImage: [
                    require('@image/shopping/kuaidi.png'),
                    require('@image/shopping/small-car.png'),
                ],
                map: {},
                geocoder: {},
                start: '',
                end: '',
                car: '',
                statusObj: {
                    isSuccess: false,
                    isDeliver: false,
                    isTransport: false,
                },
                show: !true,
                orderId: '',
            }
        },
        created() {
            const {
                id: orderId = ''
            } = this.$route.query;
            if(orderId){
                this.orderId = orderId;
            }
        },
        mounted() {
            this.createMap();
        },
        methods:{
            expressName(name){
                return String(name).includes('快递') ? name : `${name}快递`
            },
            onChangehow(){
                this.show = !this.show;
            },
            back(){
                this.$router.go(-1);
            },
            getDetail(orderId) {
                http.post(getOrderDetail, { orderId }).then(({ data }) => {
                    this.detail = data;
                    this.getExpressInfo(this.orderId)
                });
            },
            getExpressInfo(orderId){
                // var res = {"message":"ok","nu":"3950055201640","ischeck":"1","condition":"D01","com":"yunda","status":"200","state":"3","data":[{"time":"2019-03-23 13:21:54","ftime":"2019-03-23 13:21:54","context":"【武汉市】您的快件已被 合作代办点 代签收，如有问题请电联快递员：董雨昂【13147108459】，投诉电话：027-59768190。天寒地冻不停忙，如有不妥您见谅，好评激励我向上，求个五星暖心房。"},{"time":"2019-03-23 09:13:51","ftime":"2019-03-23 09:13:51","context":"【武汉市】湖北武汉黄陂区公司杨园分部 派件员 董雨昂 13147108459 正在为您派件"},{"time":"2019-03-23 06:55:27","ftime":"2019-03-23 06:55:27","context":"【武汉市】已离开 湖北武汉黄陂区公司；发往 湖北武汉黄陂区公司杨园分部"},{"time":"2019-03-23 06:52:47","ftime":"2019-03-23 06:52:47","context":"【武汉市】已到达 湖北武汉黄陂区公司；马上为您派送"},{"time":"2019-03-22 20:30:30","ftime":"2019-03-22 20:30:30","context":"【武汉市】已到达 华中枢纽"},{"time":"2019-03-22 20:30:27","ftime":"2019-03-22 20:30:27","context":"【武汉市】已离开 华中枢纽；发往 湖北武汉黄陂区公司"},{"time":"2019-03-22 20:15:30","ftime":"2019-03-22 20:15:30","context":"【武汉市】已到达 华中枢纽"},{"time":"2019-03-22 00:48:37","ftime":"2019-03-22 00:48:37","context":"【揭阳市】已离开 广东揭阳分拨中心；发往 华中枢纽"},{"time":"2019-03-22 00:46:46","ftime":"2019-03-22 00:46:46","context":"【揭阳市】已到达 广东揭阳分拨中心"},{"time":"2019-03-21 20:32:50","ftime":"2019-03-21 20:32:50","context":"【汕头市】已离开 广东汕头潮阳区公司陈店分部；发往 湖北武汉地区包"},{"time":"2019-03-21 19:05:50","ftime":"2019-03-21 19:05:50","context":"【汕头市】广东汕头潮阳区公司陈店分部 已揽收"}]}
                // this.option = res;
                http.post(expressInfoUrl, { orderId })
                    .then(res=>{
                        // var{
                        //     data: array = []
                        // } = res.data
                        // array = array.splice(2)
                        // res.data.data = array;

                        this.option = res.data;
                        this.option = res.data;
                        this.analysisExpressInfo();
                    })
            },
            analysisExpressInfo(){
                const {
                    data: array = []
                } = this.option
                var [{
                    context = ''
                }] = array;
                if(context.includes('签收')){
                    this.statusObj.isSuccess = true
                } else if(context.includes('派件')) {
                    this.statusObj.isDeliver = true;
                }else {
                    this.statusObj.isTransport = true
                }
                this.addMapMarker();
            },
            addMarker(address, falg = true){
                // 点标记显示内容，HTML要素字符串
                var startMarkerContent = 
                        `<div class="custom-content-marker">
                            <div class="left-box">发</div>
                            <div class="right-box">海口市</div>
                        </div>`
                var endMarkerContent = 
                        `<div class="custom-content-marker">
                            <div class="left-box">
                                <i class="iconhebei iconicon-receive icon-size"></i>
                            </div>
                            <div class="right-box">${this.receivingGoodsCity}</div>
                        </div>`

                var marker = new AMap.Marker({
                    position: new AMap.LngLat(address[0], address[1]),
                    // 将 html 传给 content
                    content: falg ? startMarkerContent : endMarkerContent,
                    // 以 icon 的 [center bottom] 为原点
                    offset: new AMap.Pixel(-13, -30)
                });

                // 将 markers 添加到地图
                this.map.add(marker);
            },
            getLocation(address = '四川省武侯区'){
                return new Promise((resolve, reject) => {
                    // console.log(address)
                    this.geocoder.getLocation(address, function(status, result) {
                        if (status === 'complete'&&result.geocodes.length) {
                            var lnglat = result.geocodes[0].location;
                            // console.log(lnglat)
                            resolve([lnglat.lng,lnglat.lat])
                        }else{
                            reject('根据地址查询位置失败')
                        }
                    });
                })
            },
            carDriving(){
                var truckOptions = {
                    map: this.map,
                    policy:0,
                    size:1,
                    showTraffic: false,
                    hideMarkers: true,
                    // outlineColor: '#ff0000',
                };
                var driving = new AMap.TruckDriving(truckOptions);
                var path = this.statusObj.isTransport && this.car !== '' ? [ {lnglat:[this.start[0], this.start[1]]}, {lnglat:[this.car[0], this.car[1]]}, {lnglat:[this.end[0], this.end[1]]} ] : [ {lnglat:[this.start[0], this.start[1]]}, {lnglat:[this.end[0], this.end[1]]} ];
                driving.search(path, (status, result) => {
                    if (status === 'complete') {
                        // console.log('绘制货车路线完成')
                        // console.log(result)
                    } else {
                        // console.log('获取货车规划数据失败：' + result)
                    }
                });
            },
            createMap(){
                window.onLoad  = ()=> {
                    this.map = new AMap.Map('container', {
                        resizeEnable: true,
                        // zoom: 12,//级别
                        center: [116.379028, 39.865042],
                        // center: [104.06934,30.662858],
                        lang: this.lang,
                        showIndoorMap: true, 
                        pitchEnable:false,
                        pitch: 25,
                        viewMode: "2D", 
                        showLabel: false, //不显示地图文字标记
                        // zoomEnable:false,
                        // 在PC上，取值范围为[3-18]；在移动设备上，取值范围为[3-19]
                        // zooms:[18,19],
                        // zooms:[9,19],
                        // dragEnable: false,
                        // rotateEnable: true,
                        // layers: [
                        //     new AMap.TileLayer(),
                        //     this.setImage()
                        // ]
                    });

                    this.map.on("complete", ()=>{
                        this.getDetail(this.orderId)
                        //  限定拖动位置
                        // var bounds = this.map.getBounds();
                        // this.map.setLimitBounds(bounds);

                        //  给自己点经纬度的时候使用
                        // this.map.on('click', function(e) {
                        //     console.log(
                        //         e.lnglat.getLng() + ',' + e.lnglat.getLat()
                        //     )
                        // });

                    });

                }
                var url = 'https://webapi.amap.com/maps?v=1.4.15&key=679d954abb266b740a083f410335540b&plugin=AMap.Geocoder&plugin=AMap.TruckDriving&callback=onLoad';
                this.addScript(url)
            },
            addMapMarker(){
                this.geocoder = new AMap.Geocoder({
                    // city: "010", //城市设为北京，默认：“全国”
                });

                this.getLocation('海南省博物馆').then(res=>{ 
                    this.start = res;
                    this.addMarker(this.start);
                })

                var {
                    data: array = []
                } = this.option

                //  针对在运输中的时候绘制小汽车
                if(this.statusObj.isTransport){
                    for (let index = 0, len = array.length; index < len; index++) {
                        const element = array[index];
                        let tempArray = String(element.context).split(' ');
                        if(tempArray.length>2){
                            let [,address] = tempArray
                            let tempAddress = address.split('；')[0] ?? '';
                            // console.log(tempAddress)
                            this.getLocation(tempAddress).then(res=>{ 
                                this.car = res;
                                this.addSmallCarOfToMap(res);
                            })
                            break
                        }
                    }
                }
                this.getLocation(this.detail.distribution.detailAddress?? '').then(res=>{ 
                    this.end = res; 
                    this.carDriving();
                    this.addMarker(this.end, false);
                },error=>{
                    console.log(this.start)
                    console.log(this.end)
                    console.log(this.car)
                    console.log(error)
                    // this.addMapMarker();
                })
            },
            addSmallCarOfToMap(address){
                // 点标记显示内容，HTML要素字符串
                var markerContent = 
                            // <i class="iconfont iconhuoche2 icon-car-size"></i>
                        `<div class="car-marker">
                            <img src="${this.defaultImage[1]}">' 
                        </div>`

                var marker = new AMap.Marker({
                    position: new AMap.LngLat(address[0], address[1]),
                    // 将 html 传给 content
                    content: markerContent,
                    // 以 icon 的 [center bottom] 为原点
                    offset: new AMap.Pixel(0, 0)
                });

                // 将 markers 添加到地图
                this.map.add(marker);
            },
            addScript(url, callBack = ()=>{ console.log('加载完成') }){
                var jsapi = document.createElement('script');
                jsapi.charset = 'utf-8';
                jsapi.src = url;
                document.head.appendChild(jsapi);
                // jsapi.onload = callBack();
            },
            logisticsDate(dateStr = '2019-03-23 06:55:27', falg = true){
                var array = dateStr.split(' ');
                var date = String(array[0])?? '';
                var time = String(array[1])?? '';
                if(falg)
                return date.substring(Number(date.indexOf('-')+1));
                return time.substring(0, time.lastIndexOf(':') );
            },
        },
        computed: {
            getImagePrefix() {
                return this.$store.state.shoppingBlock.bgImgPrefix || "";
            },
            userId() {
                return this.$store.state.userInfo.userId;
            },
            getImage(){
                let image = this.getImagePrefix + this.detail.ORDER_GOODS_DETAILS[0]?.COVER_URL;
                return image;
            },
            receivingGoodsCity(){
                var address = this.detail?.distribution?.detailAddress;
                var s = address.indexOf('省') > -1 ? address.indexOf('省') + 1 : 0;
                var e = address.indexOf('市') > -1 ? address.indexOf('市') + 1 : 0;
                return String(address).substring(s, e);
            },
        },
        components:{
            [Step.name]: Step,
            [Steps.name]: Steps,
            [Popup.name]: Popup,
        }
    }
</script>

<style lang="less" scoped>
    .f-s-b{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .f-c{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .container{
        // background-color: #ffffff !important;
        background-color: #EFF0FA !important;
        position: relative;
        .header{
            height:48px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 2px 0px rgba(187,187,187,0.5);
            border-radius:13px;
            left: 7px;
            right: 7px;
            top: 7px;
            position: absolute;
            z-index: 2;
            padding: 6px 13px;
            box-sizing: border-box;
            // justify-content: flex-start;
            .right-box{
                .header-image{
                    width:33px;
                    height:33px;
                    background:rgba(216,216,216,1);
                    border-radius:6px;
                    overflow: hidden;
                    margin: 0 10px;
                }
                .icon-image{
                    transform: rotate(180deg);
                    // margin-right: 10px;
                }
                .text{
                    font-size:14px;
                    font-weight:500;
                    color:rgba(102,102,96,1);
                }
            }
        }
        .map-box{
            height: 462px;
            #container{
                height: 100%;
            }
        }

        .logistics-name-box{
            background-color: #fff;
            margin: 7px;
            padding: 16px;
            border-radius:6px;
            justify-content: flex-start;
            transform: translateY(-20px);
            margin-bottom: -10px;
            .logistics-image{
                width:40px;
                height:40px;
                background:rgba(216,216,216,1);
                border-radius:6px;
                overflow: hidden;
                margin-right: 13px;
            }
            .info-box{
                width: ~'calc(100% - 53px)';
                .logistics-name{
                    font-size:14px;
                    font-weight:500;
                    color:rgba(26,27,29,1);
                    line-height:20px;
                    margin-bottom: 5px;
                }
                .logistics-number{
                    font-size:12px;
                    font-weight:400;
                    color:rgba(160,160,160,1);
                    line-height:17px;
                }
            }
        }
        .product-box{
            margin-top: 20px;
        }
        .logistics-info-box{
            padding: 7px;
            padding-top: 0;
            .info-box{
                border-radius:6px;
                overflow: hidden;
            }
        }
        // .red(){
        //     border: 1px solid red;
        // }
        .render-logistics-info-box{
            padding: 16px;
            border-radius:6px;
            overflow: hidden;
            background-color: #fff;
            margin: 7px;
            margin-top: 0;
            .item-box{
                height: auto;
                justify-content: flex-start;
                align-items: flex-start;
                margin-bottom: 10px;
                &:last-of-type{
                    margin-bottom: 0;
                    height: auto;
                    min-height: auto;
                    .info-box{
                        &::before{
                            content: none;
                        }
                    }
                }
                .date-box{
                    width: 50px;
                    text-align: center;
                    font-size:12px;
                    font-weight:400;
                    .date{
                        color:rgba(51,51,51,1);
                    }
                    .time{
                        color:rgba(178,178,178,1);
                    }
                }
                .icon-box{
                    width: 30px;
                    text-align: center;
                    position: relative;
                    vertical-align: top;
                    height: 100%;
                    .quan-box{
                        width:9px;
                        height:9px;
                        background:rgba(216,216,216,1);
                        box-sizing: border-box;
                        border-radius: 100px;
                        display: inline-block;
                        vertical-align: top;
                    }
                    .icon-quanquan{
                        color: rgba(216,216,216,1);
                        border: 1px solid rgba(216,216,216,1);;
                        padding: 2px;
                        border-radius: 100px;
                    }
                    .receiving-icon{
                        width:25px;
                        height:25px;
                        background:rgba(216,216,216,1);
                        font-size:13px;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        border-radius: 100px;
                    }
                    .icon-quanquan-active{
                        color: #ffffff;
                        border-color: rgba(255,80,1,1);
                        z-index: 1;
                        background:linear-gradient(270deg,rgba(255,80,1,1) 0%,rgba(255,133,1,1) 100%);
                    }
                    .icon-success{
                        z-index: 1;
                        color: #ff6600;
                        &::before{
                            font-size: 22px;
                        }
                    }
                }
                .info-box{
                    position: relative;
                    flex: 1;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(160,160,160,1);
                    box-sizing: border-box;
                    min-height:50px;
                    &::before{
                        content: '';
                        position: absolute;
                        height: 110%;
                        left: -16px;
                        transform: translateY(5px);
                        width: 1px;
                        background-color: rgba(216,216,216,1);
                    }

                }
            }
        }
        .popup-box{
            background-color: rgba(0, 0, 0, 0.6196078431372549);
            // background-color: #555658;
        }
    }
</style>